/*
 * Size-up / size-down nudge.
 * On the FIRST tap of a size chip (including the pre-selected default), if the
 * product carries a `size_up` / `size_down` tag and there is an adjacent
 * size in that direction, float a bubble above the size selector suggesting it.
 * The bubble is relocated to <body> so the theme's variant re-render (which
 * rebuilds <variant-selects>) can't wipe it. It stays open until the shopper
 * taps "size me up/down", "keep N", or clicks outside it. Fires once per load.
 */
(function () {
  'use strict';
  if (window.__sizeNudgeInit) return;
  window.__sizeNudgeInit = true;

  var COPY = {
    up:   { hl: 'This pair runs narrow.', lead: 'Most women take one up.',   verb: 'Size me up to ' },
    down: { hl: 'This pair runs large.',  lead: 'Most women take one down.', verb: 'Size me down to ' }
  };

  var shown = false;      // once shown, never nudge again this page load
  var nudge = null;       // the single bubble, relocated to <body>
  var dir = null;         // 'up' | 'down'
  var targetSize = null;  // the size the "go" button selects

  function sizeNum(input) {
    var n = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? null : n;
  }
  function inStock(input) { return !input.classList.contains('disabled'); }
  function pill(el) { return el && el.closest ? el.closest('.product-form__input--pill') : null; }
  function livePill() { return document.querySelector('.product-form__input--pill'); }
  function labelFor(fieldset, input) {
    return fieldset.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
  }

  function init() {
    var el = document.querySelector('.size-nudge');
    if (!el) return;
    dir = el.getAttribute('data-size-nudge');
    if (dir !== 'up' && dir !== 'down') return;
    document.body.appendChild(el);   // out of the re-render zone; positioned in document coords
    nudge = el;
  }

  // the size exactly one step in the tag's direction; null only if there is no size that way.
  // Stock is not checked: a sold-out size is still suggested, because the fit advice holds.
  function findTarget(fieldset, current) {
    var sizes = [].slice.call(fieldset.querySelectorAll('input[type="radio"]'))
      .map(function (r) { return { n: sizeNum(r) }; })
      .filter(function (s) { return s.n !== null; });
    sizes.sort(function (a, b) { return a.n - b.n; });
    var idx = -1;
    for (var i = 0; i < sizes.length; i++) { if (sizes[i].n === current) { idx = i; break; } }
    if (idx === -1) return null;
    var adj = dir === 'up' ? sizes[idx + 1] : sizes[idx - 1];
    return adj ? adj.n : null;
  }

  function place(fieldset, chip) {
    if (!nudge) return;
    var fr = fieldset.getBoundingClientRect();
    nudge.style.left  = (fr.left + window.pageXOffset) + 'px';
    nudge.style.width = fr.width + 'px';
    nudge.style.top   = (fr.top + window.pageYOffset - nudge.offsetHeight - 12) + 'px';
    var arrow = nudge.querySelector('.size-nudge__arrow');
    if (chip) {
      var cr = chip.getBoundingClientRect();
      var cx = (cr.left + cr.width / 2) - fr.left;
      arrow.style.left = Math.max(14, Math.min(cx - 6, fr.width - 26)) + 'px';
    }
  }

  function reposition() {
    if (!nudge || nudge.hasAttribute('hidden')) return;
    var fieldset = livePill();
    if (!fieldset) return;
    highlight(fieldset);
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    place(fieldset, checked ? labelFor(fieldset, checked) : null);
  }

  function highlight(fieldset) {
    var prev = fieldset.querySelector('input.size-nudge-suggest');
    if (prev) prev.classList.remove('size-nudge-suggest');
    if (targetSize === null) return;
    var radios = [].slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    for (var i = 0; i < radios.length; i++) { if (sizeNum(radios[i]) === targetSize) { radios[i].classList.add('size-nudge-suggest'); break; } }
  }

  function open(fieldset, input) {
    var cur = sizeNum(input);
    if (cur === null) return false;
    var nxt = findTarget(fieldset, cur);
    if (nxt === null) return false;             // nothing to suggest in that direction
    var c = COPY[dir];
    targetSize = nxt;
    nudge.querySelector('.size-nudge__hl').textContent = c.hl;
    nudge.querySelector('.size-nudge__body').innerHTML =
      c.lead + ' You picked a <b>' + cur + '</b> — we’d go a <b>' + nxt +
      '</b>. Size &amp; colour exchanges are always free.';
    nudge.querySelector('.size-nudge__go').textContent = c.verb + nxt;
    nudge.querySelector('.size-nudge__keep').textContent = 'Keep ' + cur;

    nudge.removeAttribute('hidden');
    highlight(fieldset);
    place(fieldset, labelFor(fieldset, input) || input);
    requestAnimationFrame(function () { nudge.classList.add('is-open'); });

    setTimeout(reposition, 350);                // settle after any variant re-render
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
    setTimeout(function () { document.addEventListener('click', onOutside, true); }, 0);
    return true;
  }

  function close() {
    if (!nudge) return;
    nudge.classList.remove('is-open');
    nudge.setAttribute('hidden', '');
    targetSize = null;
    var fs = livePill(); if (fs) { var s = fs.querySelector('input.size-nudge-suggest'); if (s) s.classList.remove('size-nudge-suggest'); }
    window.removeEventListener('scroll', reposition, true);
    window.removeEventListener('resize', reposition);
    document.removeEventListener('click', onOutside, true);
  }

  function onOutside(e) { if (nudge && !nudge.contains(e.target)) close(); }

  // First trusted tap on a size chip (capture phase, so we relocate/show before
  // the theme's change-handler re-renders <variant-selects>).
  document.addEventListener('click', function (e) {
    if (shown || !nudge || !e.isTrusted) return;
    var fieldset = pill(e.target);
    if (!fieldset) return;
    var input = e.target.closest('input[type="radio"]');
    if (!input) {
      var lbl = e.target.closest('label');
      if (lbl && lbl.htmlFor) input = document.getElementById(lbl.htmlFor);
      else if (lbl && lbl.control) input = lbl.control;
    }
    if (!input || input.type !== 'radio' || !inStock(input)) return;
    if (open(fieldset, input)) shown = true;   // lock only once actually shown
  }, true);

  // Bubble actions
  document.addEventListener('click', function (e) {
    var go = e.target.closest ? e.target.closest('.size-nudge__go') : null;
    var dismiss = e.target.closest ? e.target.closest('.size-nudge__keep, .size-nudge__close') : null;
    if (go) {
      e.stopPropagation();
      var fieldset = livePill();
      if (fieldset && targetSize !== null) {
        var radios = [].slice.call(fieldset.querySelectorAll('input[type="radio"]'));
        for (var i = 0; i < radios.length; i++) {
          if (sizeNum(radios[i]) === targetSize) { radios[i].checked = true; radios[i].dispatchEvent(new Event('change', { bubbles: true })); break; }
        }
      }
      close();
    } else if (dismiss) {
      e.stopPropagation();
      close();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
